import {create} from 'zustand';
import {User} from "/types/user-type";
import {persist} from "zustand/middleware";

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImageUrl?: string;
}

interface CommonStoreState {
  user: CurrentUser | null;
  isAdmin: boolean;
  setUser: (user: User | null) => void;
}

export const useCommonStore = create<CommonStoreState>()(
  persist(
    (set) => ({
      user: null,
      isAdmin: false,
      setUser: (user) => {
        if (!user) {
          set({ user: null, isAdmin: false });
          return;
        }
        
        set({
          user: {
            id: user.itemId,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            profileImageUrl: user.profileImageUrl,
          },
          isAdmin: user.roles.includes('admin')
        });
      },
    }),
    {name: 'user-storage'}
  )
);
